import { useEffect, useRef } from 'react'
import { secondaryButtonState, notifyButtons } from './vk-bridge-adapter'

interface SecondaryButtonOptions {
  text: string
  onClick: () => void
  color?: string
  textColor?: string
  isActive?: boolean
  position?: 'left' | 'right' | 'top' | 'bottom'
  isLoading?: boolean
}

export function useSecondaryButton(options: SecondaryButtonOptions | null) {
  const callbackRef = useRef<(() => void) | null>(null)

  useEffect(() => {
    const removeCallback = () => {
      if (!callbackRef.current) return
      const idx = secondaryButtonState.onClickCallbacks.indexOf(callbackRef.current)
      if (idx !== -1) secondaryButtonState.onClickCallbacks.splice(idx, 1)
      callbackRef.current = null
    }

    if (!options) {
      removeCallback()
      secondaryButtonState.isVisible = false
      secondaryButtonState.isProgressVisible = false
      notifyButtons()
      return () => {}
    }

    const {
      text,
      onClick,
      color = '#E8DFD8',
      textColor = '#C73B0D',
      isActive = true,
      position = 'left',
      isLoading = false,
    } = options

    removeCallback()

    const handleClick = () => { if (!isLoading && isActive) onClick() }
    callbackRef.current = handleClick
    secondaryButtonState.onClickCallbacks.push(handleClick)

    secondaryButtonState.text = text
    secondaryButtonState.color = color
    secondaryButtonState.textColor = textColor
    secondaryButtonState.isActive = isActive && !isLoading
    secondaryButtonState.isVisible = true
    secondaryButtonState.isProgressVisible = isLoading
    secondaryButtonState.position = position
    notifyButtons()

    return () => {
      removeCallback()
      secondaryButtonState.isVisible = false
      secondaryButtonState.isProgressVisible = false
      notifyButtons()
    }
  }, [
    options?.text,
    options?.onClick,
    options?.color,
    options?.textColor,
    options?.isActive,
    options?.position,
    options?.isLoading,
  ])
}
